// Traduções PT → EN (gerado a partir do código; a chave é o texto em português).
// Para corrigir um texto em inglês, edite o valor à direita.
const en = {
  "/mês": "/mo",
  "1.000 bits": "1,000 bits",
  "16:9 · Horizontal": "16:9 · Landscape",
  "1:1 · Quadrado": "1:1 · Square",
  "9:16 · Vertical": "9:16 · Portrait",
  "A ativação é feita manualmente pela nossa equipe após o pagamento. Em breve: assinatura automática.": "Activation is done manually by our team after payment. Coming soon: automatic subscription.",
  "A chave da sua conta é usada automaticamente — não precisa configurar nada por overlay.": "Your account key is used automatically — nothing to set up per overlay.",
  "A célula deve conter a URL de uma imagem.": "The cell must contain an image URL.",
  "A exclusão remove overlays, mídias, fontes, chave do YouTube e conexões. O histórico financeiro é mantido para fins fiscais.": "Deleting removes overlays, media, fonts, YouTube key and connections. Payment history is kept for tax purposes.",
  "A transmissão não possui chat ao vivo ativo.": "This stream doesn't have an active live chat.",
  "A1 ou A2:A20": "A1 or A2:A20",
  "ALERTA DE SUPER CHAT": "SUPER CHAT ALERT",
  "ALINHAR NO CANVAS": "ALIGN ON CANVAS",
  "ANIMAÇÃO DE ENTRADA": "ENTRY ANIMATION",
  "ANIMAÇÃO DE SAÍDA": "EXIT ANIMATION",
  "AO VIVO": "LIVE",
  "Abreviado (1.2k)": "Abbreviated (1.2k)",
  "Abrir Google Cloud Console": "Open Google Cloud Console",
  "Abrir editor": "Open editor",
  "Abrir painel": "Open panel",
  "Acesso ao Google Sheets desvinculado": "Google Sheets access unlinked",
  "Acesso válido até": "Access valid until",
  "Add": "Add",
  "Adicionar texto": "Add text",
  "Agora não": "Not now",
  "Aguardando mensagens…": "Waiting for messages…",
  "Alerta de Super Chat": "Super Chat alert",
  "Alerta enviado à tela": "Alert sent to screen",
  "Alinhar": "Align",
  "Alinhar ao topo": "Align top",
  "Alinhar à base": "Align bottom",
  "Alinhar à direita": "Align right",
  "Alinhar à esquerda": "Align left",
  "Altura": "Height",
  "Altura linha": "Line height",
  "Ambos": "Both",
  "Ao Vivo": "Live",
  "Arraste a barra ao lado para ajustar o tamanho.": "Drag the bar beside it to resize.",
  "Arraste mídias ou clique. .mov .mp4 .webm .gif .png .jpg": "Drag media here or click. .mov .mp4 .webm .gif .png .jpg",
  "Arraste para ajustar o tamanho": "Drag to resize",
  "Assinar {nome}": "Subscribe to {nome}",
  "Ativar a API": "Enable the API",
  "Ativar a YouTube Data API v3": "Enable the YouTube Data API v3",
  "Aumentar zoom": "Zoom in",
  "Autoplay": "Autoplay",
  "Baixo": "Down",
  "Barra de meta": "Goal bar",
  "Barra de progresso de inscritos (YouTube)": "Subscriber progress bar (YouTube)",
  "Bem-vindo ao LiveGrafX!": "Welcome to LiveGrafX!",
  "Botão": "Button",
  "Buscar mídia": "Search media",
  "CAIXA DE CHAT": "CHAT BOX",
  "CAMADA": "LAYER",
  "CAMADAS": "LAYERS",
  "CASA": "HOME",
  "CHAT AO VIVO": "LIVE CHAT",
  "COMENTÁRIO EM DESTAQUE": "FEATURED COMMENT",
  "COMEÇA EM": "STARTING IN",
  "COMEÇAR COM UM TEMPLATE": "START FROM A TEMPLATE",
  "CONTEÚDO": "CONTENT",
  "CONTORNO & SOMBRA": "OUTLINE & SHADOW",
  "COTA YOUTUBE": "YOUTUBE QUOTA",
  "Caixa de chat": "Chat box",
  "Camadas": "Layers",
  "Canal desconectado": "Channel disconnected",
  "Canal {nome} conectado": "Channel {nome} connected",
  "Cancelar": "Cancel",
  "Cantos": "Corners",
  "Cargo • Descrição": "Role • Description",
  "Carregando...": "Loading...",
  "Casa x Fora com tempo": "Home vs Away with clock",
  "Centralizar horizontalmente": "Center horizontally",
  "Centralizar no canvas": "Center on canvas",
  "Centralizar verticalmente": "Center vertically",
  "Centro": "Center",
  "Chave da API do YouTube": "YouTube API key",
  "Chave do YouTube conectada": "YouTube key connected",
  "Chave removida": "Key removed",
  "Chave validada e salva! Ela vale para todos os seus overlays.": "Key validated and saved! It works for all your overlays.",
  "Cima": "Up",
  "Clique em Ativar na página que abrir.": "Click Enable on the page that opens.",
  "Clique em Criar credenciais → Chave de API, e copie a chave gerada.": "Click Create credentials → API key, and copy the generated key.",
  "Colar e validar": "Paste and validate",
  "Cole o link de uma planilha pública, ou conecte sua conta Google para usar planilhas privadas. Depois vincule textos e imagens a células nas Propriedades de cada elemento.": "Paste the link to a public spreadsheet, or connect your Google account to use private spreadsheets. Then bind text and images to cells in each element's Properties.",
  "Comentário em destaque": "Featured comment",
  "Começar com Google": "Get started with Google",
  "Começar com {nome}": "Start with {nome}",
  "Como usar no OBS / vMix": "How to use in OBS / vMix",
  "Compartilhe este link com quem vai controlar o overlay ao vivo (ligar/desligar elementos, placar, cronômetro, chat) — sem precisar de login. Ele não pode editar o design.": "Share this link with whoever will control the overlay live (toggle elements, scoreboard, timer, chat) — no login needed. They can't edit the design.",
  "Completo (1.234)": "Full (1,234)",
  "Conectada": "Connected",
  "Conectado": "Connected",
  "Conectando…": "Connecting…",
  "Conectar": "Connect",
  "Conectar agora": "Connect now",
  "Conectar seu YouTube": "Connect your YouTube",
  "Conecte a planilha no botão \"Planilha\" do topo.": "Connect the spreadsheet with the Google Sheets button at the top.",
  "Conecte seu YouTube": "Connect your YouTube",
  "Conecte sua transmissão para usar espectadores, curtidas e chat ao vivo nos elementos do overlay.": "Connect your stream to use live viewers, likes and chat in your overlay elements.",
  "Conecte um canal da Twitch primeiro.": "Connect a Twitch channel first.",
  "Conecte um canal para usar espectadores ao vivo e seguidores nos elementos dinâmicos do overlay.": "Connect a channel to use live viewers and followers in the overlay's dynamic elements.",
  "Conecte uma transmissão do YouTube primeiro.": "Connect a YouTube stream first.",
  "Configurar agora": "Set up now",
  "Configurar chave": "Set up key",
  "Conta criada em": "Account created on",
  "Conta excluída": "Account deleted",
  "Contador de audiência em tempo real": "Real-time audience counter",
  "Contagem regressiva de abertura": "Opening countdown",
  "Continue com esse trabalho incrível! ❤️": "Keep up the amazing work! ❤️",
  "Contorno": "Outline",
  "Cor": "Color",
  "Cor autor": "Author color",
  "Cor barra": "Bar color",
  "Cor borda": "Border color",
  "Cor fundo": "Background color",
  "Cor sombra": "Shadow color",
  "Cor texto": "Text color",
  "Criando...": "Creating...",
  "Criar a chave": "Create the key",
  "Criar e editar": "Create and edit",
  "Criar pasta": "Create folder",
  "Criar/selecionar um projeto": "Create/select a project",
  "Crie um projeto novo (qualquer nome serve) ou use um que já tenha.": "Create a new project (any name works) or use one you already have.",
  "Crie, edite e coloque no ar.": "Create, edit and go live.",
  "Cronômetro": "Timer",
  "Curtidas": "Likes",
  "Célula única": "Single cell",
  "Célula/Intervalo": "Cell/Range",
  "Círculo": "Circle",
  "DADO DA TWITCH": "TWITCH DATA",
  "DADO DO YOUTUBE": "YOUTUBE DATA",
  "DONO": "OWNER",
  "Dado": "Data",
  "Dado Twitch": "Twitch Data",
  "Dado YouTube": "YouTube Data",
  "Dado da Twitch": "Twitch data",
  "Dado do YouTube": "YouTube data",
  "Dados da Twitch ao vivo": "Live Twitch data",
  "Dados da conta": "Account details",
  "Dados do YouTube ao vivo": "Live YouTube data",
  "Delay (ms)": "Delay (ms)",
  "Demonstração": "Demo",
  "Demonstração do LiveGrafX": "LiveGrafX demo",
  "Desbloqueie integrações ao vivo, mais projetos e armazenamento.": "Unlock live integrations, more projects and storage.",
  "Desconectar": "Disconnect",
  "Desconectar canal": "Disconnect channel",
  "Desconectar transmissão": "Disconnect stream",
  "Desfoque": "Blur",
  "Destaque": "Featured",
  "Diminuir zoom": "Zoom out",
  "Direita": "Right",
  "Direção": "Direction",
  "Disparar animação": "Trigger animation",
  "Duplicar": "Duplicate",
  "Duplicar elemento selecionado (Ctrl+C, Ctrl+V)": "Duplicate selected element (Ctrl+C, Ctrl+V)",
  "Duração (ms)": "Duration (ms)",
  "Duração (s)": "Duration (s)",
  "Duração ao vivo": "Live duration",
  "Dê um nome ao seu overlay para começar a editar.": "Give your overlay a name to start editing.",
  "E-mail (login Google — não editável)": "Email (Google login — not editable)",
  "EXCLUIR sua conta LiveGrafX?\n\nSerão apagados: overlays, mídias, fontes, chave do YouTube e conexões (Google/Twitch). Esta ação não pode ser desfeita.": "DELETE your LiveGrafX account?\n\nThis will erase: overlays, media, fonts, YouTube key and connections (Google/Twitch). This action cannot be undone.",
  "Efeito": "Effect",
  "Elemento": "Element",
  "Elemento colado": "Element pasted",
  "Elemento copiado (Ctrl+V para colar)": "Element copied (Ctrl+V to paste)",
  "Elemento duplicado": "Element duplicated",
  "Empilhar lista": "Stack list",
  "Entrar com Google": "Sign in with Google",
  "Enviando…": "Uploading…",
  "Enviar fonte": "Upload font",
  "Envie suas fontes (.ttf, .otf, .woff, .woff2) e use-as nos textos do overlay.": "Upload your fonts (.ttf, .otf, .woff, .woff2) and use them in your overlay text.",
  "Erro": "Error",
  "Erro ao criar a partir do template": "Error creating from template",
  "Erro ao criar overlay": "Error creating overlay",
  "Erro ao criar pasta": "Error creating folder",
  "Erro ao duplicar": "Error duplicating",
  "Erro ao excluir pasta": "Error deleting folder",
  "Erro ao ler o chat.": "Error reading the chat.",
  "Erro ao mover": "Error moving",
  "Erro ao salvar": "Error saving",
  "Erro no chat": "Chat error",
  "Escolha seu plano": "Choose your plan",
  "Espaçamento": "Spacing",
  "Espectadores": "Viewers",
  "Espectadores ao Vivo": "Live Viewers",
  "Espectadores ao vivo": "Live viewers",
  "Espessura": "Thickness",
  "Esquerda": "Left",
  "Esta ação não pode ser desfeita.": "This action cannot be undone.",
  "Estrela": "Star",
  "Ex: {n} assistindo": "E.g. {n} watching",
  "Excluir": "Delete",
  "Excluir \"{nome}\"?": "Delete \"{nome}\"?",
  "Excluir a pasta \"{nome}\"?": "Delete the folder \"{nome}\"?",
  "Excluir minha conta": "Delete my account",
  "Excluir mídia?": "Delete media?",
  "Excluir pasta": "Delete folder",
  "Exiba espectadores, likes e comentários ao vivo nos seus overlays.": "Show live viewers, likes and comments on your overlays.",
  "Exibição": "Display",
  "Expirado": "Expired",
  "Explorar a versão gratuita": "Explore the free version",
  "FORA": "AWAY",
  "FORMA": "SHAPE",
  "FORMATO": "FORMAT",
  "FUNDO": "BACKGROUND",
  "FUNDO DO BLOCO": "BLOCK BACKGROUND",
  "FUNÇÃO AO VIVO": "LIVE ROLE",
  "Faixa": "Stripe",
  "Falha ao carregar link": "Failed to load link",
  "Falha ao carregar perfil": "Failed to load profile",
  "Falha ao conectar": "Failed to connect",
  "Falha ao conectar canal": "Failed to connect channel",
  "Falha ao conectar planilha": "Failed to connect spreadsheet",
  "Falha ao desconectar": "Failed to disconnect",
  "Falha ao desvincular o Google Sheets": "Failed to unlink Google Sheets",
  "Falha ao enviar {arquivo}": "Failed to upload {arquivo}",
  "Falha ao enviar {arquivo}: {erro}": "Failed to upload {arquivo}: {erro}",
  "Falha ao excluir conta": "Failed to delete account",
  "Falha ao gerar link": "Failed to generate link",
  "Falha ao iniciar a vinculação do Google Sheets": "Failed to start Google Sheets linking",
  "Falha ao iniciar chat": "Failed to start chat",
  "Falha ao remover": "Failed to remove",
  "Falha ao validar a chave. Tente novamente.": "Failed to validate the key. Please try again.",
  "Falha ao vincular o Google Sheets. Tente novamente.": "Failed to link Google Sheets. Please try again.",
  "Fazer upgrade": "Upgrade",
  "Fazer upgrade / renovar": "Upgrade / renew",
  "Faça o upgrade agora para não perder o acesso às integrações ao vivo, aos seus projetos e ao seu armazenamento.": "Upgrade now so you don't lose access to live integrations, your projects and your storage.",
  "Fechar": "Close",
  "Fique tranquilo:": "Don't worry:",
  "Fixado na tela": "Pinned on screen",
  "Fonte": "Font",
  "Fonte removida": "Font removed",
  "Fontes personalizadas": "Custom fonts",
  "Forma": "Shape",
  "Formato": "Format",
  "Formato do overlay": "Overlay format",
  "Formato {w}×{h}": "Format {w}×{h}",
  "Fundo": "Background",
  "Fundo barra": "Bar background",
  "Função": "Role",
  "GOOGLE SHEETS": "GOOGLE SHEETS",
  "Gerar novo": "Generate new",
  "Gerenciar fontes": "Manage fonts",
  "Google Sheets vinculado": "Google Sheets linked",
  "Google Sheets vinculado com sucesso": "Google Sheets linked successfully",
  "Grupo": "Group",
  "Horizontal": "Horizontal",
  "Idioma": "Language",
  "Inclui overlays ilimitados, mídias com transparência, YouTube/Twitch, planilhas e link de operador.": "Includes unlimited overlays, media with transparency, YouTube/Twitch, spreadsheets and operator link.",
  "Iniciar": "Start",
  "Iniciar chat (transmissão conectada)": "Start chat (connected stream)",
  "Iniciar chat da Twitch": "Start Twitch chat",
  "Iniciar chat do YouTube": "Start YouTube chat",
  "Iniciar modo demonstração": "Start demo mode",
  "Inscritos": "Subscribers",
  "Integrações ao vivo (YouTube, Twitch, Google Sheets), mais projetos e armazenamento fazem parte dos planos pagos.": "Live integrations (YouTube, Twitch, Google Sheets), more projects and storage are part of the paid plans.",
  "Intervalo (s)": "Interval (s)",
  "Ir para Credenciais": "Go to Credentials",
  "L / A": "W / H",
  "Largura": "Width",
  "Lendo chat da Twitch": "Reading Twitch chat",
  "Lendo chat do YouTube": "Reading YouTube chat",
  "Lendo chat do YouTube + Twitch": "Reading YouTube + Twitch chat",
  "Link de operador inválido ou expirado.": "Invalid or expired operator link.",
  "Link do operador": "Operator link",
  "Link do operador copiado!": "Operator link copied!",
  "Login cancelado: você precisa autorizar o acesso com o Google para entrar.": "Login canceled: you need to authorize Google access to sign in.",
  "Loop": "Loop",
  "Losango": "Diamond",
  "MEMBRO": "MEMBER",
  "META DE INSCRITOS": "SUBSCRIBER GOAL",
  "Mais opções": "More options",
  "Manda um salve pro Recife 🙌": "Shout-out to Recife 🙌",
  "Mesclagem": "Blend",
  "Meta": "Goal",
  "Meta Inscritos": "Subscriber Goal",
  "Meta de Inscritos": "Subscriber Goal",
  "Meta de seguidores": "Follower goal",
  "Meta quase batida 👀": "Goal almost reached 👀",
  "Meu Perfil": "My Profile",
  "Meus Overlays": "My Overlays",
  "Modelo": "Template",
  "Modo": "Mode",
  "Modo demonstração ativo": "Demo mode on",
  "Mostrar avatar": "Show avatar",
  "Mostrar preview": "Show preview",
  "Mostrar templates": "Show templates",
  "Mover para": "Move to",
  "Movido para a pasta": "Moved to folder",
  "MÍDIA": "MEDIA",
  "Máx. linhas": "Max. rows",
  "Máx. mensagens": "Max. messages",
  "Métrica": "Metric",
  "Mídias": "Media",
  "NOME DO CONVIDADO": "GUEST NAME",
  "Nenhum": "None",
  "Nenhum overlay ainda. Crie o primeiro!": "No overlays yet. Create your first one!",
  "Nenhum overlay nesta pasta.": "No overlays in this folder.",
  "Nenhum pagamento por aqui ainda.": "No payments here yet.",
  "Nenhuma": "None",
  "Nenhuma fonte enviada ainda.": "No fonts uploaded yet.",
  "Nenhuma mídia.": "No media.",
  "Nenhuma pasta criada": "No folders yet",
  "Nome": "Name",
  "Nome + cargo do convidado": "Guest name + role",
  "Nome da pasta": "Folder name",
  "Nome do canal (ou link twitch.tv/canal)": "Channel name (or twitch.tv/channel link)",
  "Nome do grupo": "Group name",
  "Nome do overlay": "Overlay name",
  "Nova pasta": "New folder",
  "Novo Overlay": "New Overlay",
  "Novo link gerado. O link anterior deixou de funcionar.": "New link generated. The previous link no longer works.",
  "Novo nome": "New name",
  "Não foi possível entrar com o Google. Tente novamente.": "Couldn't sign in with Google. Please try again.",
  "Não foi possível iniciar o login com o Google. Tente novamente.": "Couldn't start Google sign-in. Please try again.",
  "Não precisa de login nem de chave — basta o nome do canal.": "No login or key needed — just the channel name.",
  "O acesso às integrações e ao editor foi pausado. Reative um plano para voltar a transmitir com tudo funcionando.": "Access to integrations and the editor has been paused. Reactivate a plan to get back to streaming with everything working.",
  "OPERADOR": "OPERATOR",
  "Ocultar preview": "Hide preview",
  "Ocultar tudo (emergência)": "Hide everything (emergency)",
  "Opac. fundo": "Bg opacity",
  "Opac. sombra": "Shadow opacity",
  "Opacidade": "Opacity",
  "Organize seus overlays em pastas.": "Organize your overlays into folders.",
  "Os dados atualizam automaticamente e refletem em tempo real nos elementos dinâmicos do overlay.": "Data updates automatically and is reflected in real time in the overlay's dynamic elements.",
  "Os overlays dentro dela não serão apagados — apenas voltam para \"Sem pasta\".": "The overlays inside it won't be deleted — they just go back to \"No folder\".",
  "Outros": "Other",
  "Overlay duplicado": "Overlay duplicated",
  "Overlay excluído": "Overlay deleted",
  "Overlay não encontrado": "Overlay not found",
  "Overlay ou chave inválidos": "Invalid overlay or key",
  "PREVIEW · NO AR": "PREVIEW · ON AIR",
  "PREVIEW": "PREVIEW",
  "Não foi possível carregar os arquivos": "Could not load the files",
  "Tentar de novo": "Try again",
  "Subir grupo": "Move group up",
  "{n} camadas selecionadas": "{n} layers selected",
  "Limpar seleção": "Clear selection",
  "Shift+clique adiciona ou tira camadas. Arraste uma delas para mover todas; as setas do menu Camadas ordenam todas juntas.": "Shift+click adds or removes layers. Drag one of them to move all; the arrows in the Layers menu reorder them together.",
  "Há camadas bloqueadas na seleção: elas não se movem.": "Some selected layers are locked: they will not move.",
  "Move a seleção inteira, mantendo a posição relativa entre as camadas.": "Moves the whole selection, keeping the layers' relative positions.",
  "Mostrar todas": "Show all",
  "Ocultar todas": "Hide all",
  "Desbloquear todas": "Unlock all",
  "Bloquear todas": "Lock all",
  "Excluir selecionadas": "Delete selected",
  "Camadas excluídas (Ctrl+Z para desfazer)": "Layers deleted (Ctrl+Z to undo)",
  "Descer grupo": "Move group down",
  "NO AR": "ON AIR",
  "{n} selecionado(s)": "{n} selected",
  "Selecionar para o PREVIEW": "Select for PREVIEW",
  "Selecionar grupo para o PREVIEW": "Select group for PREVIEW",
  "Padding": "Padding",
  "Pagamentos": "Payments",
  "Painel": "Panel",
  "Painel Admin": "Admin Panel",
  "Para editar, use tablet ou desktop": "To edit, use a tablet or desktop",
  "Parar": "Stop",
  "Pasta criada": "Folder created",
  "Pasta excluída": "Folder deleted",
  "Pausar": "Pause",
  "Permissão do Google Sheets negada. Autorize o acesso para usar planilhas privadas.": "Google Sheets permission denied. Authorize access to use private spreadsheets.",
  "Personalizado": "Custom",
  "Peso": "Weight",
  "Placar": "Scoreboard",
  "Placar (+/-)": "Scoreboard (+/-)",
  "Placar Casa": "Home Score",
  "Placar Fora": "Away Score",
  "Planilha conectada": "Spreadsheet connected",
  "Planilha desconectada": "Spreadsheet disconnected",
  "Planilha privada conectada": "Private spreadsheet connected",
  "Planilhas privadas": "Private spreadsheets",
  "Plano atual": "Current plan",
  "Plano e assinatura": "Plan & subscription",
  "Planos": "Plans",
  "Plataforma": "Platform",
  "Preenchimento": "Fill",
  "Prever animação": "Preview animation",
  "Preview do ar": "On-air preview",
  "Preview do overlay no ar": "Preview of the on-air overlay",
  "Primeira vez aqui e já virei fã do canal!": "First time here and I'm already a fan of the channel!",
  "Privada": "Private",
  "Processando": "Processing",
  "Progressiva": "Count up",
  "Pronto": "Ready",
  "Propriedades": "Properties",
  "Prévia do fluxo: subir mídia, editar textos e usar a URL no OBS.": "Workflow preview: upload media, edit text, and use the URL in OBS.",
  "Página não encontrada.": "Page not found.",
  "Pílula": "Pill",
  "Pública": "Public",
  "Quadrado 1:1 · 1080×1080": "Square 1:1 · 1080×1080",
  "Quando você renovar seu acesso, o histórico aparece nesta aba.": "When you renew your access, the history will show up in this tab.",
  "Que overlay lindo! 🔥": "Such a sick overlay! 🔥",
  "Raio": "Radius",
  "Raio borda": "Border radius",
  "Reativar meu plano": "Reactivate my plan",
  "Reconectando…": "Reconnecting…",
  "Recolher": "Collapse",
  "Reconectar": "Reconnect",
  "Redirecionando…": "Redirecting…",
  "Reenviar": "Retry",
  "Regressiva": "Countdown",
  "Reinicia diariamente (limite padrão 10.000 un./dia).": "Resets daily (default limit 10,000 units/day).",
  "Remover": "Remove",
  "Remover a chave do YouTube da sua conta?": "Remove the YouTube key from your account?",
  "Removido da pasta": "Removed from folder",
  "Repórter · Direto do estúdio": "Reporter · Live from the studio",
  "Retângulo": "Rectangle",
  "Revelar (wipe)": "Reveal (wipe)",
  "Rotacionar lista": "Rotate list",
  "Rotação": "Rotation",
  "Rótulo": "Label",
  "Sair": "Sign out",
  "Sair da conta": "Sign out",
  "Salto (bounce)": "Bounce",
  "Salvando…": "Saving…",
  "Salvar": "Save",
  "Salve da resenha!": "Hey from the crew!",
  "Salve da resenha, tmj!": "Hey crew, love you all!",
  "Salvo": "Saved",
  "Seguidores": "Followers",
  "Selecione um elemento para editar.": "Select an element to edit.",
  "Sem elementos.": "No elements.",
  "Sem grupo": "No group",
  "Sem limite definido": "No limit set",
  "Sem pasta": "No folder",
  "Sem plano": "No plan",
  "Seu acesso expira {quando}": "Your access expires {quando}",
  "Seu plano expirou": "Your plan has expired",
  "Seu texto aqui": "Your text here",
  "Sombra": "Shadow",
  "Sombra X/Y": "Shadow X/Y",
  "Sombra blur": "Shadow blur",
  "Sua chave do YouTube está inválida (pode ter sido revogada). Atualize a chave para continuar.": "Your YouTube key is invalid (it may have been revoked). Update the key to continue.",
  "Sub (presente)": "Sub (gift)",
  "Suba sua mídia, edite os textos, copie a URL e cole no OBS como Browser Source. Tudo atualiza em tempo real.": "Upload your media, edit the text, copy the URL and paste it into OBS as a Browser Source. Everything updates in real time.",
  "Subtítulo": "Subtitle",
  "TIPOGRAFIA": "TYPOGRAPHY",
  "TRANSFORMAR": "TRANSFORM",
  "TUDO ATUALIZA EM TEMPO REAL NO OBS": "EVERYTHING UPDATES IN REAL TIME IN OBS",
  "Tamanho": "Size",
  "Tem certeza absoluta? Todos os seus dados serão removidos.": "Are you absolutely sure? All your data will be removed.",
  "Tempo": "Time",
  "Texto": "Text",
  "Texto ao vivo": "Live text",
  "Time Casa": "Home Team",
  "Time Fora": "Away Team",
  "Tipo": "Type",
  "Todos": "All",
  "Token regenerado. Atualize a URL no OBS.": "Token regenerated. Update the URL in OBS.",
  "Transmissão": "Stream",
  "Transmissão conectada": "Stream connected",
  "Transmissão desconectada": "Stream disconnected",
  "Triângulo": "Triangle",
  "Trocar chave": "Change key",
  "Título": "Title",
  "URL copiada!": "URL copied!",
  "URL ou ID do vídeo/transmissão": "Video/stream URL or ID",
  "Uma chave gratuita do Google Cloud, configurada uma única vez, vale para todos os seus overlays. Se você já tem a chave, pule direto para o passo 4.": "A free Google Cloud key, set up just once, works for all your overlays. If you already have a key, skip straight to step 4.",
  "Uma única chave para toda a conta — todos os seus overlays a reutilizam automaticamente.": "A single key for the whole account — all your overlays reuse it automatically.",
  "Upgrade para {nome}": "Upgrade to {nome}",
  "Upload concluído. Transcodificando…": "Upload complete. Transcoding…",
  "Use": "Use",
  "Ver planos": "See plans",
  "Ver todas as perguntas frequentes": "See all FAQs",
  "Vertical": "Vertical",
  "Vertical 9:16 · 1080×1920": "Portrait 9:16 · 1080×1920",
  "Vincular": "Bind",
  "Vincular Google Sheets": "Link Google Sheets",
  "Visualizações": "Views",
  "Você ainda não conectou uma chave do YouTube na sua conta.": "You haven't connected a YouTube key to your account yet.",
  "Você está no": "You're on the",
  "Voltar": "Back",
  "Voltar ao início": "Back to home",
  "X / Y": "X / Y",
  "Zoom: Ctrl + / Ctrl - / Ctrl 0 · Ctrl + roda do mouse": "Zoom: Ctrl + / Ctrl - / Ctrl 0 · Ctrl + mouse wheel",
  "alerta": "alert",
  "amanhã": "tomorrow",
  "antes de serem excluídos. Reative dentro desse prazo e recupere tudo.": "before being deleted. Reactivate within that period and get everything back.",
  "ao vivo": "live",
  "assistindo": "watching",
  "ativo": "active",
  "atualizar": "refresh",
  "canais": "channels",
  "concluí este passo": "I've done this step",
  "conectado": "connected",
  "configurada": "configured",
  "definir base": "set base",
  "demonstração · do editor ao ar": "demo · from editor to on-air",
  "desafixar": "unpin",
  "desativado": "disabled",
  "desvincular": "unlink",
  "em {n} dias": "in {n} days",
  "ex: gaules": "e.g. gaules",
  "expirado": "expired",
  "fixar": "pin",
  "hoje": "today",
  "livre": "free size",
  "não configurada": "not configured",
  "não configurado": "not set up",
  "onde o número deve aparecer.": "where the number should appear.",
  "pago": "paid",
  "plano gratuito": "free plan",
  "reprovar": "reject",
  "seg": "sec",
  "seus projetos ficam guardados por 30 dias": "your projects are kept for 30 days",
  "un.": "units",
  "vídeos": "videos",
  "zerar": "reset",
  "{arquivo}: formato não suportado": "{arquivo}: unsupported format",
  "{nome} (cópia)": "{nome} (copy)",
  "{n} dia restante · vence às 00:00 (São Paulo)": "{n} day left · expires at 00:00 (São Paulo time)",
  "{n} dias de acesso": "{n} days of access",
  "{n} dias restantes · vence às 00:00 (São Paulo)": "{n} days left · expires at 00:00 (São Paulo time)",
  "{n} elementos": "{n} elements",
  "{n} fonte": "{n} source",
  "{n} fonte(s) enviada(s)": "{n} font(s) uploaded",
  "{n} fontes": "{n} sources",
  "Última validação:": "Last validated:",
  "— uma demonstração para você conhecer o editor de overlays, textos em tempo real e a saída para OBS/vMix.": "— a demo so you can try the overlay editor, real-time text and the OBS/vMix output.",
  "＋ Novo grupo": "＋ New group",
  "Bloquear": "Lock",
  "Desbloquear": "Unlock",
  "Bloqueada": "Locked",
  "Oculta": "Hidden",
  "Ocultar": "Hide",
  "Mostrar": "Show",
  "Mais ações": "More actions",
  "Subir camada": "Move layer up",
  "Descer camada": "Move layer down",
  "Recolher grupo": "Collapse group",
  "Expandir grupo": "Expand group",
  "A animação do grupo roda ao ligar/desligar o grupo no Ao Vivo, junto com as animações de cada camada.": "The group animation plays when the group is turned on/off in Live, together with each layer's own animations.",
  "ANIMAÇÃO DE ENTRADA DO GRUPO": "GROUP ENTRY ANIMATION",
  "ANIMAÇÃO DE SAÍDA DO GRUPO": "GROUP EXIT ANIMATION",
  "Agrupar camada": "Group layer",
  "Aplicar": "Apply",
  "Desagrupar": "Ungroup",
  "Escolha o grupo de \"{nome}\".": "Choose the group for \"{nome}\".",
  "Grupo colado": "Group pasted",
  "Grupo copiado (Ctrl+V para colar)": "Group copied (Ctrl+V to paste)",
  "Grupo duplicado": "Group duplicated",
  "Grupo excluído (Ctrl+Z para desfazer)": "Group deleted (Ctrl+Z to undo)",
  "Há camadas bloqueadas neste grupo: arrastar e redimensionar no canvas estão desativados.": "This group has locked layers: dragging and resizing on the canvas are disabled.",
  "Mover todas as camadas de \"{nome}\" para outro grupo.": "Move all layers of \"{nome}\" to another group.",
  "O grupo é editado como um bloco. Dê um duplo clique numa camada no canvas para editá-la sozinha.": "The group is edited as one block. Double-click a layer on the canvas to edit it on its own.",
  "O tamanho muda de forma proporcional: posições, tamanhos e fontes das camadas acompanham.": "Size changes proportionally: layer positions, sizes and fonts scale along.",
  "Organizar grupo": "Organize group",
  "Remover do grupo": "Remove from group",
  "Selecionar o grupo": "Select the group",
  "Selecione uma camada ou um grupo para agrupar.": "Select a layer or a group to group.",
  "atual": "current",
  "duplo clique para editar uma camada": "double-click to edit a layer",
  "{n} camadas": "{n} layers",
  "Expandir seção": "Expand section",
  "Recolher seção": "Collapse section",
  "Topo": "Top",
  "Inferior": "Bottom",
  "Alinhar vert.": "Vertical align",
  // Perfil: Projetos e Uploads
  "Projetos": "Projects",
  "Uploads": "Uploads",
  "Você ainda não criou nenhum projeto.": "You haven't created any projects yet.",
  "{n} projeto": "{n} project",
  "{n} projetos": "{n} projects",
  "{n} elemento": "{n} element",
  "atualizado em {d}": "updated {d}",
  "Abrir no editor": "Open in editor",
  "Filtrar por formato": "Filter by format",
  "Todos os formatos": "All formats",
  "Imagens": "Images",
  "Vídeos": "Videos",
  "Fontes": "Fonts",
  "Filtrar por data": "Filter by date",
  "Recentes (até {n} dias)": "Recent (up to {n} days)",
  "Antigos (+{n} dias)": "Older (+{n} days)",
  "{a} de {b} arquivos": "{a} of {b} files",
  "Nenhum arquivo com esses filtros.": "No files match these filters.",
  "Nenhum arquivo enviado ainda.": "No files uploaded yet.",
  "Abrir o arquivo original": "Open the original file",
  "erro": "error",
  "processando": "processing",
  "pendente": "pending",
  "Voltar ao zoom ajustado à tela": "Back to fit-to-screen zoom",
  "Adicionar formas": "Add shapes",
  "Chat ao vivo": "Live chat",
  "Chat (mensagens)": "Chat (messages)",
  "Link do operador · 1 operador online": "Operator link · 1 operator online",
  "Link do operador · {n} operadores online": "Operator link · {n} operators online",
  "Recolher texto": "Collapse text",
  "Alterar texto": "Edit text",
  "Texto vinculado ao Google Sheets": "Text linked to Google Sheets",
  "Configurar a chave do YouTube": "Set up the YouTube key",
  "configurar": "set up",
  "Recolher textos do grupo": "Collapse group texts",
  "Mostrar textos do grupo": "Show group texts",
  "YouTube conectado": "YouTube connected",
  "Twitch conectada": "Twitch connected",
};

export default en;
